import React from 'react'

export default function StarRatingComponent({ rat_cat }) {
    const StarRating = ({ rating }) => {
        const maxStars = 5;
        return (
            <div className="star-sec">
                {[...Array(maxStars)].map((_, i) => (
                    <i
                        key={i}
                        className={i < rating ? "fa-solid fa-star" : "fa-solid fa-star disabled"}
                    ></i>
                ))}
            </div>
        );
    };

    return (
        <div>
            <StarRating rating={Number(rat_cat?.rating)} />

        </div>
    )
}
